/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-07-26 10:26:11
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-07-26 17:33:13
 * @FilePath: \合联\wms\src\api\forecastManagement\doorToDoor.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios, { buildApi } from '@/libs/api.request';
import { getToken } from "@/libs/util";

let name = '/warehouse/men'

export const apis = buildApi({
  get: [name + '/index&list', name+'/log/:id&log'],
  post: [name + '/delivery', name + '/receiptSign']
})

export const uploads = data => {
  return axios.request({
    url: "/warehouse/deliveryService/uploads",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
};